module.exports = __webpack_public_path__ + "img/beam-head.b7bf4fcf.png";